// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Bank = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Bank = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Bank = _exports.Bank = function Bank(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M17.8462 15.9005H16.9744V14.956C16.9744 14.452 16.6841 14.2004 16.1026 14.2004H15.8846V8.91133H16.1026C16.6841 8.91133 16.9744 8.65973 16.9744 8.15575V6.22215C16.9744 5.93579 16.7878 5.67451 16.4923 5.54681L10.585 2.98676C10.2171 2.82733 9.78378 2.82733 9.41501 2.98676L3.50772 5.54681C3.21219 5.67451 3.02564 5.93654 3.02564 6.22215V8.15575C3.02564 8.65973 3.31595 8.91133 3.89744 8.91133H4.11538V14.2004H3.89744C3.31595 14.2004 3.02564 14.452 3.02564 14.956V15.9005H2.15385C1.79292 15.9005 1.5 16.1544 1.5 16.4672C1.5 16.78 1.79292 17.0339 2.15385 17.0339H17.8462C18.2071 17.0339 18.5 16.78 18.5 16.4672C18.5 16.1544 18.2071 15.9005 17.8462 15.9005ZM10 4.94452C10.6015 4.94452 11.0897 5.36765 11.0897 5.889C11.0897 6.41035 10.6015 6.83348 10 6.83348C9.39846 6.83348 8.91026 6.41035 8.91026 5.889C8.91026 5.36765 9.39846 4.94452 10 4.94452ZM5.42308 14.2004V8.91133H7.60256V14.2004H5.42308ZM8.91026 14.2004V8.91133H11.0897V14.2004H8.91026ZM12.3974 14.2004V8.91133H14.5769V14.2004H12.3974Z",
      fill: "currentColor"
    }));
  };
});
